export function buildProjectFairYearOptions(years: unknown[], currentYear = new Date().getFullYear()) {
  return [...new Set([...years, currentYear].map(Number).filter(Number.isInteger))]
    .sort((a, b) => b - a)
    .map((year) => ({ value: String(year), display: String(year) }));
}
